import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const GameInstructions = () => {
  const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>游戏说明</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5>单词消消乐 - 游戏规则</h5>
        <ul>
          <li>点击卡片选择中文或英文单词</li>
          <li>找到相同意思的中英文卡片进行配对</li>
          <li>成功配对后卡片会消失</li>
          <li>消除所有卡片即可通关</li>
          <li>每关卡片数量会逐渐增加</li>
          <li>用时越短、步数越少，分数越高</li>
        </ul>
        <p><strong>提示：</strong>仔细观察卡片内容，寻找对应的中英文单词！</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          开始游戏
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GameInstructions;